import { axiosInstance } from ".";

const verificationRequestsList = async ({ params }) =>
  await axiosInstance.get(
    "/api/CompanyBusinessVerificationRequest/Get",
    {
      params,
      paramsSerializer: { indexes: null }
    }
  );

const offPlatformVerificationRequestDetails = async ({ id }) =>
  await axiosInstance.get(
    "/api/CompanyBusinessVerificationRequest/GetOffPlatformRequestById",
    { params: { id } }
  );

const onlinePaymentVerificationRequestDetails = async ({ id }) =>
  await axiosInstance.get(
    "/api/CompanyBusinessVerificationRequest/GetOnlinePaymentRequestById",
    { params: { id } }
  );

const bankTransferVerificationRequestDetails = async ({ id }) =>
  await axiosInstance.get(
    "/api/CompanyBusinessVerificationRequest/GetBankTransferRequestById",
    { params: { id } }
  );

const sendRequiredVerificationDocuments = async (data) =>
  await axiosInstance.post(
    "/api/CompanyBusinessVerificationRequest/AddRequiredDocuments",
    data
  );

const approveOffPlatformDocs = async (data) =>
  await axiosInstance.put(
    "/api/CompanyBusinessVerificationRequest/ApproveOffPlatformDocs",
    data
  );

const requestEditOffPlatformDocs = async (data) =>
  await axiosInstance.put(
    "/api/CompanyBusinessVerificationRequest/RequestEditOffPlatformDocs",
    data
  );

const approveVerificationRequest = async (data) =>
  await axiosInstance.put(
    "/api/CompanyBusinessVerificationRequest/ApproveRequest",
    data
  );

const rejectVerificationRequest = async (data) =>
  await axiosInstance.put(
    "/api/CompanyBusinessVerificationRequest/RejectRequest",
    data
  );

export {
  verificationRequestsList,
  offPlatformVerificationRequestDetails,
  onlinePaymentVerificationRequestDetails,
  bankTransferVerificationRequestDetails,
  sendRequiredVerificationDocuments,
  approveOffPlatformDocs,
  requestEditOffPlatformDocs,
  approveVerificationRequest,
  rejectVerificationRequest
};
